class Hamburger {
	constructor() {
		this.$scope = $('.hamburger');

		if (this.$scope.length < 1) {
			return;
		}
		this.init();
	}

	init() {
		this.$scope.each((i, button) => {
			const targetSelector = $(button).data('bs-target');
			const $offcanvas = $(targetSelector);

			if ($offcanvas.length) {
				$offcanvas.on('show.bs.offcanvas', () => {
					$(button).addClass('is-active');
				});

				$offcanvas.on('hide.bs.offcanvas', () => {
					$(button).removeClass('is-active');
				});
			}
		});
	}
}

export default new Hamburger();
